import { render, staticRenderFns } from "./SegmentationText.vue?vue&type=template&id=70122646"
import script from "./SegmentationText.vue?vue&type=script&lang=js"
export * from "./SegmentationText.vue?vue&type=script&lang=js"
import style0 from "./SegmentationText.vue?vue&type=style&index=0&id=70122646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports